export default __webpack_public_path__ + "static/media/ic_filled_bookmark.572e68d7.svg";